import React, { Component } from "react";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import LoadingCircular from "../LoadingCircular";

class NewsDetail extends Component {
  state = {
    news: {},
    isLoading: false,
  };
  async componentDidMount() {
    const { newsId } = this.props;
    this.setState({ isLoading: true });
    const res = await fetch(`/ng/api/GetNews/Detail?id=${newsId}`);
    const data = await res.json();
    this.setState({ news: data, isLoading: false });
  }
  render() {
    const { news, isLoading } = this.state;
    return (
      <>
        <LoadingCircular open={isLoading} />
        <Divider sx={{ mt: 1, mb: 1 }}>نمایش خبر</Divider>
        <strong>
          {news.Title} - {news.DateTime}
        </strong>
        <Typography sx={{ textAlign: "justify", mt: 2 }}>
          {news.Body}
        </Typography>
      </>
    );
  }
}

export default NewsDetail;
